import Address from '@/services/Address';
export default (function (_ref) {
  var Vue = _ref.Vue;
  Vue.prototype.$address = Address;
});